import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router/index';
import '@/router/guard';
import routerMain from '@/router/router-main';
import store from '@/store';
import * as filters from './filters';
import directives from './directives';
import * as $http from './axios';
import util from './utils/util';
import ElementUI from 'element-ui';
import '@/plugins/message.js';
import components from './global-components';
import 'normalize.css/normalize.css';
import '@/styles/base.scss';
import '@/styles/element.scss';
import FastClick from 'fastclick';
import * as firebase from 'firebase/app';
import 'firebase/auth';
// import { adjust_report } from '@/utils/adjust';
import report from '@/utils/report';
import VueLuckyCanvas from '@lucky-canvas/vue';
// import * as Sentry from '@sentry/vue';
// import { BrowserTracing } from '@sentry/tracing';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import BugsnagPerformance from '@bugsnag/browser-performance';
import i18n from './locales/';

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});
Vue.use(ElementUI);
Vue.use(components);
Vue.use(VueLuckyCanvas);
Vue.config.productionTip = false;
Vue.prototype.$http = $http;
Vue.prototype.$util = util;
Vue.prototype.$adjust = () => {};

const isProduction = process.env.VUE_APP_ENV === 'production';
const bugsnagApiKey = isProduction
  ? '21916e082c162ddca9f9091ea1d30892'
  : 'ee239587a93839b3d06e4c2db174e532';
// if (isProduction) {
Bugsnag.start({
  apiKey: bugsnagApiKey,
  plugins: [new BugsnagPluginVue()],
  appVersion: '1.0.0',
  redactedKeys: [
    'token', // exact match: "access_token"
    'Token', // exact match: "access_token"
    'refreshToken', // exact match: "access_token"
    /^password$/i // case-insensitive: "password", "PASSWORD", "PaSsWoRd"
  ]
});
BugsnagPerformance.start({
  apiKey: bugsnagApiKey,
  appVersion: '1.0.0'
});
const bugsnagVue = Bugsnag.getPlugin('vue');
bugsnagVue.installVueErrorHandler(Vue);
// if (process.env.VUE_APP_ENV != 'development') {
//   Sentry.init({
//     Vue,
//     dsn: !isProduction
//       ? 'https://ceae4f3ccdb54fad8afcddcfe9c30ceb@sentry.nicee.tw/8'
//       : 'https://9cfcc46be08225b0417f6684e7ea2de9@o4506993216389120.ingest.us.sentry.io/4506993220124672',
//     integrations: [
//       new BrowserTracing({
//         routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//         tracingOrigins: !isProduction
//           ? ['localhost', 'test.nicee.tw', 'app.test.nicee.app', /^\//]
//           : ['nicee.tw', 'app.nicee.app', /^\//]
//       })
//     ],
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
//     maxValueLength: 1000,
//     enabled: !isProduction?false:true
//   });
//   Sentry.setTags({
//     nicee: 'web'
//   });
// }
store.dispatch('app/setRegion', {
  region: localStorage.getItem('REGION') || 'US',
})
Vue.config.errorHandler = function(error) {
  // 检查错误类型是否为 ChunkLoadError
  if (error && error.name && error.name === 'ChunkLoadError') {
    window.location.reload();
  } else {
    // 默认的错误处理行为
    console.error('Error occurred:', error);
    // 执行默认的错误处理行为，如显示错误提示
  }
};
// 路由动态加载
router.addRoutes(routerMain);

/**
 * 二次封装confirm
 */
const confirm = Vue.prototype.$confirm;
Vue.prototype.$confirm = (params = {}) => {
  const content = params.content || '';
  delete params.content;
  const title = params.title || '';
  delete params.title;
  params.customClass = `fps-message-box ${
    title ? ' has-title' : ''
  } ${params.customClass || ''}`;
  if (
    (params.confirmButtonText && params.confirmButtonText.length > 6) ||
    (params.cancelButtonText && params.cancelButtonText.length > 6)
  ) {
    params.customClass += ' long-btn';
  }
  if (params.showClose) {
    params.customClass += ' has-close';
  }
  if (params.showCancelButton !== false) {
    params.customClass += ' two-btn';
  }
  params = Object.assign({ showClose: false }, params);
  return confirm(content, title, params);
};

// token相关逻辑
let token = window.location.href.match(/(\?|&)token=([^&]*)(&|$)/i);
token = (token && token[2]) || null;
let refreshToken = window.location.href.match(
  /(\?|&)refreshToken=([^&]*)(&|$)/i
);
refreshToken = (refreshToken && refreshToken[2]) || null;
if (token || refreshToken) {
  store.commit('app/SET_TOKEN', {
    token,
    refreshToken
  });
}

// 更新未讀消息數量
window.setOpenerWindowUnreadMsg = obj => {
  store.dispatch('app/reveicedMessage', obj);
  if (
    window.opener &&
    typeof window.opener.setOpenerWindowUnreadMsg === 'function'
  ) {
    window.opener.setOpenerWindowUnreadMsg(obj);
  }
};

// firebase，line等第三方工具
window.firebase = firebase;
const firebaseConfig = {
  apiKey: 'AIzaSyCYZZlJE61RwLQPCbQApy-cou2apfQnVkE',
  authDomain: 'auth.nicee.tw',
  databaseURL: 'https://fps-login-dev.firebaseio.com',
  projectId: 'fps-login-dev',
  storageBucket: 'fps-login-dev.appspot.com',
  messagingSenderId: '830395383996',
  appId: '1:830395383996:web:66950219100d48ba1210b9',
  measurementId: 'G-96DYSLMDPV'
};
firebase.initializeApp(firebaseConfig);
window.firebaseRedirectResultFn = params => {
  window.firebaseRedirectResultFn.redirectObj = params;
  const param = window.firebaseRedirectResultFn.params;
  if (param) {
    window.firebaseRedirectResultFn.p = new Promise(() => {}).then(
      ({ code, result }) => {
        if (code) {
          window.firebaseRedirectResultFn.redirectObj.resolve(result);
        } else {
          window.firebaseRedirectResultFn.redirectObj.reject(result);
        }
      }
    );
    window.firebaseRedirectResultFn.p.resolve(param);
  }
};
firebase
  .auth()
  .getRedirectResult()
  .then(result => {
    if (window.firebaseRedirectResultFn.redirectObj) {
      window.firebaseRedirectResultFn.redirectObj.resolve(result);
    } else {
      window.firebaseRedirectResultFn.params = {
        code: 1,
        result
      };
    }
  })
  .catch(result => {
    if (window.firebaseRedirectResultFn.redirectObj) {
      window.firebaseRedirectResultFn.redirectObj.reject(result);
    } else {
      window.firebaseRedirectResultFn.params = {
        code: 0,
        result
      };
    }
  });
window.lineChannelId = 1653936595;
// 修复移动端 ios input框点击无效（或者需要点击多次）
FastClick.prototype.focus = function(targetElement) {
  var length;
  if (
    targetElement.setSelectionRange &&
    targetElement.type.indexOf('date') !== 0 &&
    targetElement.type !== 'time' &&
    targetElement.type !== 'month'
  ) {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};
FastClick.attach(document.body);

const UA = navigator.userAgent;
window.isFacebook = () => {
  let rules = /fban|fbav/i;
  return rules.test(UA);
};
window.shouldRedirect = () => {
  let rules = [/fban|fbav/i, /line/i, /micromessenger/i, /instagram/i];
  return rules.some(reg => reg.test(UA));
};
Vue.prototype.isPC = window.innerWidth >= 600;
Vue.prototype.$report = report;
const vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');

// 添加下载或者打开App方法
if (util.nativeType) {
  window.loadApp = params => {
    const defaultParams = {
      content: i18n.t('main_1947'),
      confirmButtonText: i18n.t('main_1948'),
      cancelButtonText: i18n.t('upgrade_page_layout_header_42')
    };
    params = Object.assign(defaultParams, params || {});
    vm.$confirm(params).then(() => {
      util.jumpAppStore();
    });
  };
}
